import React, { useState, useEffect } from 'react';

import Button from '../CommonButton';

import styles from './carousel.css';

const Carousel = ({ header, subHeader, carouselData }) => {
    const [activeSlide, setActiveSlide] = useState(0);
    // Slider Content Classes to set for animation
    const [sliderContentClassList, setSliderContentClassList] = useState(`${styles['slider-content']} ${styles['slider-content--active']}`);

    // Set slider active class with a minor delay to get the animation
    useEffect(() => {
        setTimeout(() => { setSliderContentClassList(`${styles['slider-content']} ${styles['slider-content--active']}`); }, 10);
    }, [activeSlide]);

    const sliderClick = (side) => {
        const slidesLength = carouselData.length;
        if (side === 'left') {
            // set slider class to get slide reverse animation
            setSliderContentClassList(`${styles['slider-content']} ${styles['slider-content--reverse']}`);
            const activeSlideIndex = activeSlide === 0 ? slidesLength - 1 : activeSlide - 1;
            setActiveSlide(activeSlideIndex);
        }

        if (side === 'right') {
            setSliderContentClassList(`${styles['slider-content']}`);
            const activeSlideIndex = activeSlide === slidesLength - 1 ? 0 : activeSlide + 1;
            setActiveSlide(activeSlideIndex);
        }
    };

    // Carousel Data
    const { author, quote, cite, src } = carouselData[activeSlide];

    return (
        <div className={styles.wrapper}>
            <hgroup className={styles['header-grp']}>
                <h2 className={styles.header}>
                    {header}
                </h2>
                <h3 className={styles['sub-header']}>
                    {subHeader}
                </h3>
            </hgroup>

            <div className={styles['slider-wrapper']}>
                <Button modifier={`${styles['slider-btn']} ${styles['slider-btn--left']}`} onClick={() => sliderClick('left')}>
                </Button>
                <blockquote className={sliderContentClassList}>
                    <img
                        alt={author}
                        className={styles['slider-img']}
                        // eslint-disable-next-line global-require, import/no-dynamic-require
                        src={require(`../../images/${src}`)}
                    />
                    <div className={styles['slider-testimonial']}>
                        <q className={styles['slider-testimonial-quote']}>{quote}</q>
                        <cite className={styles['slider-testimonial-cite']}>{cite}</cite>
                    </div>
                </blockquote>
                <Button modifier={`${styles['slider-btn']} ${styles['slider-btn--right']}`} onClick={() => sliderClick('right')}>
                </Button>
            </div>
        </div>
    );
};

export default Carousel;
